import $ from 'jquery';
import 'jquery.easing';

const $cookieConsent = $('.cookie-consent');

// 2019.03.08
$cookieConsent.each((i, el) => {
  const $el = $(el);
  const cookieConsentAPI = '/api/cookie/consent';

  function cookieConsentGrant() {
    $.ajax({
      method: 'GET',
      url: `${cookieConsentAPI}/grant`
    });
  }

// function cookieConsentRevoke() {
//   $.ajax({
//     method: 'GET',
//     url: `${cookieConsentAPI}/revoke`
//   });
// }

  $el.find('button.close').click(e => {
    e.preventDefault();
    cookieConsentGrant();
  });
});
